import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { inject } from 'mobx-react';
import { Mutation } from 'react-apollo';
import CommonAccount from '../../fragments/account';

const LOGIN = gql`
  mutation LoginWithPcc($code: String!, $state: String!) {
    loginWithPcc(code: $code, state: $state) {
      authToken
      myProfile {
        ...CommonAccount
      }
    }
  }
  ${CommonAccount}
`;

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  @withRouter
  @inject('authStore')
  class WithLoginMutation extends Component {
    static propTypes = {
      authStore: PropTypes.object.isRequired,
      router: PropTypes.object.isRequired,
    };

    handleLoginComplete = data => {
      const { authStore } = this.props;
      const { setAuthToken, setLoginMethod, setProfile, setRole } = authStore;
      const {
        loginWithPcc: { authToken, myProfile },
      } = data;
      setRole(myProfile.role);
      setAuthToken(authToken);
      setProfile(myProfile);
      setLoginMethod('pcc');
    };

    renderPassThrough = () => <Comp {...this.props} />;

    render() {
      if (!process.browser) return this.renderPassThrough();
      const { searchParams } = new URL(window.location);
      const [code, state] = ['code', 'state'].map(key => searchParams.get(key));
      if (!(code && state)) return this.renderPassThrough();

      return (
        <Mutation
          mutation={LOGIN}
          onCompleted={this.handleLoginComplete}
          variables={{ code, state }}
          ssr={false}
        >
          {(login, { data, loading, error }) => (
            <Comp
              {...this.props}
              pccOnLogin={login}
              pccAuthToken={data ? data.loginWithPcc.authToken : ''}
              pccIsLoadingLogin={loading}
              pccLoginError={error}
            />
          )}
        </Mutation>
      );
    }
  }

  hoistNonReactStatics(WithLoginMutation, Comp);

  return WithLoginMutation;
};
